import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { ShiftResource, shiftsGetShiftsForDate } from '~/generated';
import { extractData } from '~/utils/query-utils';
import { ShiftCollection } from '~/model/shift-collection';

export const useShiftsForDate = (
  year: number,
  month: number,
  day: number,
  expand?: string[],
  options: Omit<UseQueryOptions<ShiftResource[], unknown>, 'queryKey'> = {}
) =>
  useQuery({
    ...(options || {}),
    queryFn: () =>
      extractData(
        shiftsGetShiftsForDate({
          path: { year, month, day },
          query: { expand },
        })
      ),
    select(data) {
      return new ShiftCollection(data);
    },
    queryKey: ['shifts', year, month, day, expand],
  });
